import { IconProps } from './types';

const MousePointer = ({ className, strokeWidth }: IconProps) => {
    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            role="img"
            strokeWidth={strokeWidth}
        >
            <path
                d="M10.0835 19.8016C10.0214 19.9383 9.91974 20.0533 9.79161 20.1315C9.66348 20.2098 9.51482 20.2478 9.36485 20.2406C9.21488 20.2334 9.07052 20.1814 8.95044 20.0913C8.83037 20.0012 8.7401 19.8771 8.69134 19.7351L3.79102 4.72852C3.7509 4.59821 3.74706 4.45943 3.77991 4.3271C3.81276 4.19477 3.88107 4.0739 3.97748 3.97748C4.07389 3.88107 4.19477 3.81276 4.3271 3.77991C4.45943 3.74706 4.59821 3.7509 4.72852 3.79102L19.7379 8.68852C19.8799 8.73729 20.004 8.82755 20.0941 8.94763C20.1842 9.06771 20.2363 9.21207 20.2434 9.36204C20.2506 9.51201 20.2126 9.66067 20.1343 9.7888C20.0561 9.91693 19.9412 10.0186 19.8045 10.0807L15.6073 11.906C15.4952 11.9549 15.3967 12.0304 15.3205 12.126C15.2443 12.2217 15.1926 12.3345 15.17 12.4546C15.1473 12.5748 15.1544 12.6987 15.1906 12.8155C15.2268 12.9323 15.291 13.0385 15.3776 13.1248L20.0341 17.7813C20.1747 17.922 20.2536 18.1127 20.2536 18.3115C20.2536 18.5103 20.1747 18.701 20.0341 18.8416L18.8463 20.0304C18.7057 20.1709 18.515 20.2499 18.3162 20.2499C18.1174 20.2499 17.9267 20.1709 17.786 20.0304L13.1276 15.3748C13.0412 15.2882 12.935 15.224 12.8181 15.1879C12.7013 15.1518 12.5773 15.1448 12.4572 15.1676C12.337 15.1903 12.2242 15.2421 12.1286 15.3184C12.0331 15.3947 11.9576 15.4932 11.9088 15.6054L10.0835 19.8016Z"
                stroke="currentColor"
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default MousePointer;
